import { Tooltip } from '@odo/shared-ui';
import type { MouseEvent } from 'react';
import { AssigneeAvatar, UnassignedAvatar } from './AssigneeAvatar';
import { AssigneeName } from './AssigneeName';

interface AssigneeTriggerProps {
    assignedTo: string | null;
    isMe: boolean;
    assigneeName: string;
    assigneeColor: string;
    /** Accessible name; needed when several selectors sit on one screen. */
    ariaLabel?: string;
    onClick: (event: MouseEvent) => void;
}

/** Fixed-width so the column never shifts; narrower cells ellipsize the name. */
export function AssigneeTrigger({
    assignedTo,
    isMe,
    assigneeName,
    assigneeColor,
    ariaLabel,
    onClick
}: AssigneeTriggerProps) {
    return (
        <Tooltip content="Assign someone" disabled={Boolean(assignedTo)}>
            <button
                type="button"
                aria-label={ariaLabel}
                onClick={onClick}
                className="flex items-center gap-1.5 group w-[110px] max-w-full"
            >
                {assignedTo ? (
                    <>
                        <AssigneeAvatar name={assigneeName} color={assigneeColor} size="md" />
                        <AssigneeName
                            fullname={assigneeName}
                            isMe={isMe}
                            className="text-xs text-gray-700 font-medium"
                        />
                    </>
                ) : (
                    <UnassignedAvatar size="md" />
                )}
            </button>
        </Tooltip>
    );
}
